import { render, staticRenderFns } from "./dash_detail.vue?vue&type=template&id=3bbc1bef&scoped=true&"
import script from "./dash_detail.vue?vue&type=script&lang=js&"
export * from "./dash_detail.vue?vue&type=script&lang=js&"
import style0 from "./dash_detail.vue?vue&type=style&index=0&id=3bbc1bef&prod&scoped=true&lang=css&"
import style1 from "./dash_detail.vue?vue&type=style&index=1&id=3bbc1bef&prod&lang=scss&scoped=true&"
import style2 from "./dash_detail.vue?vue&type=style&index=2&id=3bbc1bef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc1bef",
  null
  
)

export default component.exports